var render, staticRenderFns
import script from "./QuickInspectionCostComponent.vue?vue&type=script&lang=ts&"
export * from "./QuickInspectionCostComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuickInspectionCostComponent.vue?vue&type=style&index=0&id=2eecd215&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eecd215",
  null
  
)

export default component.exports